module.exports = __webpack_public_path__ + "img/icon-state-down.7f4be326.svg";